import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "page_title"
  }, [_vm._v("電能案場管理")]), _c('v-tabs', {
    staticClass: "tab_wrap",
    attrs: {
      "color": "#70a1c6"
    },
    on: {
      "change": _vm.handleChangeTab
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "tab-value": "新增案場",
      "ripple": false
    }
  }, [_vm._v("新增案場")]), _c('v-tab', {
    attrs: {
      "tab-value": "修改案場",
      "ripple": false
    }
  }, [_vm._v("修改案場")])], 1), _c('div', {
    staticClass: "d-flex justify-content-between content_wrap"
  }, [_c('div', {
    staticClass: "textInput w-50"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_vm.tab === '新增案場' ? _c('v-text-field', {
    staticClass: "mr-5 w-50",
    attrs: {
      "label": "案場名稱",
      "color": "energy_blue_dark",
      "outlined": ""
    },
    model: {
      value: _vm.fieldName,
      callback: function callback($$v) {
        _vm.fieldName = $$v;
      },
      expression: "fieldName"
    }
  }) : _c('v-autocomplete', {
    staticClass: "textSelect mr-5 w-50",
    attrs: {
      "label": "案場名稱",
      "items": _vm.getFieldNameList,
      "color": "energy_blue_dark",
      "item-color": "energy_blue_dark",
      "outlined": "",
      "attach": "",
      "menu-props": {
        maxHeight: '450px'
      }
    },
    on: {
      "change": _vm.handleChangeFieldName
    },
    model: {
      value: _vm.fieldName,
      callback: function callback($$v) {
        _vm.fieldName = $$v;
      },
      expression: "fieldName"
    }
  }), _c('v-autocomplete', {
    staticClass: "textSelect w-50",
    attrs: {
      "label": "PV 來源",
      "items": _vm.pvSourceOptions,
      "color": "energy_blue_dark",
      "item-color": "energy_blue_dark",
      "outlined": "",
      "attach": "",
      "clearable": "",
      "menu-props": {
        maxHeight: '450px'
      }
    },
    model: {
      value: _vm.pvSource,
      callback: function callback($$v) {
        _vm.pvSource = $$v;
      },
      expression: "pvSource"
    }
  })], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    staticClass: "mr-5 w-50",
    attrs: {
      "label": "經度",
      "type": "number",
      "min": -180,
      "max": 180,
      "color": "energy_blue_dark",
      "outlined": ""
    },
    model: {
      value: _vm.longitude,
      callback: function callback($$v) {
        _vm.longitude = _vm._n($$v);
      },
      expression: "longitude"
    }
  }), _c('v-text-field', {
    staticClass: "w-50",
    attrs: {
      "label": "緯度",
      "type": "number",
      "min": -90,
      "max": 90,
      "color": "energy_blue_dark",
      "outlined": ""
    },
    model: {
      value: _vm.latitude,
      callback: function callback($$v) {
        _vm.latitude = _vm._n($$v);
      },
      expression: "latitude"
    }
  })], 1), _c('div', {
    staticClass: "page_subtitle mb-1"
  }, [_vm._v("電表資訊")]), _c('span', {
    staticClass: "page_text"
  }, [_vm._v("點選「+」號即可新增電表欄位輸入格")]), _c('div', {
    staticClass: "mt-6"
  }, [_vm._l(_vm.meterMapping, function (m, mIdx) {
    return _c('div', {
      key: mIdx,
      staticClass: "d-flex position-relative"
    }, [_c('v-text-field', {
      staticClass: "mr-5 w-50",
      attrs: {
        "label": "".concat(mIdx + 1, " \u96FB\u8868\u540D\u7A31"),
        "color": "energy_blue_dark",
        "outlined": "",
        "clearable": ""
      },
      model: {
        value: m.meterName,
        callback: function callback($$v) {
          _vm.$set(m, "meterName", $$v);
        },
        expression: "m.meterName"
      }
    }), _c('div', {
      staticClass: "d-flex w-50"
    }, [_c('v-text-field', {
      staticClass: "mr-3 w-50",
      attrs: {
        "label": "電表位置",
        "color": "energy_blue_dark",
        "outlined": ""
      },
      model: {
        value: m.meterLocation,
        callback: function callback($$v) {
          _vm.$set(m, "meterLocation", $$v);
        },
        expression: "m.meterLocation"
      }
    }), _c('v-select', {
      staticClass: "textSelect w-50",
      attrs: {
        "items": _vm.meterTypeOptions,
        "label": "電表類型",
        "color": "energy_blue_dark",
        "item-color": "energy_blue_dark",
        "menu-props": {
          offsetY: true
        },
        "outlined": "",
        "attach": ""
      },
      model: {
        value: m.meterType,
        callback: function callback($$v) {
          _vm.$set(m, "meterType", $$v);
        },
        expression: "m.meterType"
      }
    })], 1), _c('v-btn', {
      staticClass: "btn_meter_remove my-2",
      attrs: {
        "color": "#ebebeb",
        "fab": "",
        "depressed": "",
        "outlined": "",
        "small": ""
      },
      on: {
        "click": function click($event) {
          return _vm.handleRemoveMeter(mIdx, m.mId);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "#a3a3a3"
      }
    }, [_vm._v("mdi-minus")])], 1)], 1);
  }), _c('v-btn', {
    staticClass: "btn_meter_add",
    attrs: {
      "color": "#ebebeb",
      "fab": "",
      "depressed": "",
      "small": "",
      "ripple": false
    },
    on: {
      "click": _vm.handleAddMeter
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#a3a3a3"
    }
  }, [_vm._v("mdi-plus")])], 1)], 2)]), _c('div', {
    staticClass: "w-50 d-none flex-column"
  }, [_c('div', {
    staticClass: "page_subtitle mb-1"
  }, [_vm._v("檔案上傳")]), _c('span', {
    staticClass: "page_text"
  }, [_vm._v("支援格式：ppt、pdf、word、excel、jpg、png")]), _c('div', [_c('v-text-field', {
    staticClass: "textInput mt-5 mb-4",
    attrs: {
      "label": "",
      "placeholder": "搜尋檔案名稱關鍵字",
      "color": "energy_blue_dark",
      "append-icon": "mdi-magnify",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.searchInput,
      callback: function callback($$v) {
        _vm.searchInput = $$v;
      },
      expression: "searchInput"
    }
  })], 1), _c('div', {
    staticClass: "file_wrap position-relative flex-fill"
  }, [_vm._m(0), _c('div', {
    staticClass: "file_content_wrap overflow-y-scroll"
  }, [_vm._l(_vm.filteredFiles, function (f) {
    return _c('div', {
      key: f.id,
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "mx-6"
    }), _c('v-tooltip', {
      attrs: {
        "disabled": f.name.length < 13,
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('div', _vm._g(_vm._b({
            staticClass: "file_content flex-grow-1 file_name cursor-default"
          }, 'div', attrs, false), on), [_vm._v(" " + _vm._s(f.name) + " ")])];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(f.name))])]), _c('div', {
      staticClass: "file_content cursor-default d-flex justify-center"
    }, [_c('span', {
      staticClass: "file_type",
      class: ["badge-".concat(f.type)]
    }, [_vm._v(" " + _vm._s(f.type) + " ")])]), _c('div', {
      staticClass: "file_content text-center file_size"
    }, [_vm._v(" " + _vm._s(_vm.formatFileSize(f.size)) + " ")]), _c('div', {
      staticClass: "file_content text-center file_delete"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.handleRemoveFile(f.id);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1)], 1);
  }), _c('label', {
    staticClass: "btn_file_add"
  }, [_c('v-btn', {
    attrs: {
      "color": "#8ecde4",
      "fab": "",
      "depressed": "",
      "small": "",
      "dark": "",
      "ripple": false
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.inputFile.click();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1), _c('input', {
    ref: "inputFile",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": ".pdf,.doc,.docx,.csv,.xls,.xlsx,.ppt,.pptx,.png,.jpg,.jpeg",
      "multiple": ""
    },
    on: {
      "change": _vm.handleChangeFiles
    }
  })], 1)], 2)]), _c('div', {
    staticClass: "page_text text-right mt-3"
  }, [_vm._v(" " + _vm._s(_vm.files.length) + " 個檔案，共 " + _vm._s(_vm.filesSize) + " ")])])]), _c('div', {
    staticClass: "d-flex mt-10"
  }, [_vm.tab === '修改案場' ? _c('v-btn', {
    staticClass: "mr-5",
    attrs: {
      "color": "error",
      "ripple": false,
      "elevation": ""
    },
    on: {
      "click": _vm.handleDeleteInfo
    }
  }, [_vm._v(" 刪除案場 ")]) : _vm._e(), _c('v-btn', {
    staticClass: "text-white",
    class: {
      '': _vm.tab === '新增案場'
    },
    attrs: {
      "color": _vm.tab === '修改案場' ? 'energy_green' : 'energy_blue_dark',
      "ripple": false,
      "elevation": ""
    },
    on: {
      "click": function click($event) {
        return _vm.handleSubmitInfo(_vm.tab);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.tab) + " ")])], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "d-flex file_title_wrap"
  }, [_c('div', {
    staticClass: "mx-6"
  }), _c('div', {
    staticClass: "file_content flex-grow-1"
  }, [_vm._v("檔案名稱")]), _c('div', {
    staticClass: "file_content text-center"
  }, [_vm._v("檔案格式")]), _c('div', {
    staticClass: "file_content text-center"
  }, [_vm._v("檔案大小")]), _c('div', {
    staticClass: "file_content text-center"
  }, [_vm._v("檔案刪除")]), _c('div', {
    staticStyle: {
      "width": "7px"
    }
  })]);
}];
export { render, staticRenderFns };